// src/hooks/useNotifications.js
import { useState, useEffect, useCallback } from "react";
import {
  collection, query, orderBy, limit, onSnapshot, doc, updateDoc, writeBatch,
} from "firebase/firestore";
import { db } from "../firebase";

const MAX_NOTIFS = 50;

export function useNotifications(uid) {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!uid) return;
    setLoading(true);
    const q = query(
      collection(db, "users", uid, "notifications"),
      orderBy("createdAt", "desc"),
      limit(MAX_NOTIFS)
    );
    return onSnapshot(
      q,
      (snap) => {
        setNotifications(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
        setLoading(false);
      },
      () => setLoading(false)
    );
  }, [uid]);

  const markRead = useCallback(async (notifId) => {
    if (!uid) return;
    await updateDoc(doc(db, "users", uid, "notifications", notifId), { read: true });
  }, [uid]);

  const markAllRead = useCallback(async () => {
    if (!uid) return;
    const unread = notifications.filter((n) => !n.read);
    if (!unread.length) return;
    const batch = writeBatch(db);
    unread.forEach((n) => {
      batch.update(doc(db, "users", uid, "notifications", n.id), { read: true });
    });
    await batch.commit();
  }, [uid, notifications]);

  const unreadCount = notifications.filter((n) => !n.read).length;

  return { notifications, loading, unreadCount, markRead, markAllRead };
}
